import { render } from "./QuestionApp.vue?vue&type=template&id=833c10a4"
import script from "./QuestionApp.vue?vue&type=script&lang=js"
export * from "./QuestionApp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\pc\\desktop\\quiz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__